import React from 'react';
import { useAppState } from 'src/state-management/state-provider';
import { UserRole } from 'src/api/Api';
import { Routes, Route, Navigate, useLocation, matchPath } from 'react-router-dom';
import Navigation from 'src/view/components/navigation/Navigation';
import { appRoutes } from './routes.config';

const AuthenticatedRoutes: React.FC = () => {
  const { state } = useAppState();
  const { user } = state;
  const location = useLocation();

  if (!user) {
    return (
      <Routes>
        <Route path="*" element={<Navigate to="/auth" replace />} />
      </Routes>
    );
  }

  const userRoles = user.role;

  const filteredRoutes = appRoutes.filter(route =>
    route.roles.some(role => userRoles.includes(role))
  );

  const defaultRoute = () => {
    if (userRoles.includes(UserRole.Admin)) return '/admin/projects';
    if (userRoles.includes(UserRole.Employee)) return '/landing';
    if (userRoles.includes(UserRole.User)) return '/landing';
    return '/auth';
  };

  const currentRoute = appRoutes.find(route => matchPath(route.path, location.pathname));

  const routesContent = (
    <Routes>
      {filteredRoutes.map(route => {
        const PageComponent = route.component;
        let element = <PageComponent {...route.props} />;

        if (route.wrapper) {
          const wrappers = Array.isArray(route.wrapper) ? route.wrapper : [route.wrapper];
          element = wrappers.reduceRight((acc, Wrapper) => {
            return <Wrapper>{acc}</Wrapper>;
          }, element);
        }

        return <Route key={route.path} path={route.path} element={element} />;
      })}
      <Route path="*" element={<Navigate to={defaultRoute()} replace />} />
    </Routes>
  );

  if (currentRoute?.withNav === false) {
    return routesContent;
  }

  return <Navigation>{routesContent}</Navigation>;
};

export default AuthenticatedRoutes;
